import { Route, Routes } from "react-router-dom";
import { LoginScreen } from "../pages/public/loginScreen";
import { ExpireScreen } from "../pages/public/expireScreen";

export const LibreRouter = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginScreen />}></Route>
      <Route path="/expire" element={<ExpireScreen />}></Route>
      <Route path="/actualiz" element={<LoginScreen />}></Route>
      <Route path="/*" element={<LoginScreen />}></Route>
    </Routes>
  );
};
